export default {
  lightTransparentGrey: '#fcfcfed4',
  grey8: '#F4F5F8',
  lightWarningColor: '#cc605b'
};
